import { requestUpdateCustomer as requestUpdateCustomerApi } from "@eisinc/App/Services/CustomersService";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { UpdateShipToApiParameter } from "@insite/client-framework/Services/CustomersService";

import { ShipToModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandler<UpdateShipToApiParameter, ShipToModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await requestUpdateCustomerApi(props.apiParameter);
};

export const chain = [PopulateApiParameter, SendDataToApi];

const requestUpdateShipTo = createHandlerChainRunner(chain, "RequestUpdateShipTo");
export default requestUpdateShipTo;
